
let _kuaishou = {

    //加载基础代码
    load: function(){
        let js = '(function(root) {\n' +
            '        var ksscript = document.createElement(\'script\');\n' +
            '        ksscript.setAttribute(\'charset\', \'utf-8\');\n' +
            '        ksscript.src = \'//p1-yx.adkwai.com/udata/pkg/ks-ad-trace-sdk/ks-trace.3.2.0.min.js\';\n' +
            '        var s = document.getElementsByTagName(\'script\')[0];\n' +
            '        s.parentNode.insertBefore(ksscript, s);\n' +
            '    })(window);';

        let _head = document.getElementsByTagName("head")[0];
        let script = document.createElement("script");
        script.append(js);
        _head.appendChild(script);
    },

    //加载事件代码 - 转化ID
    submit: function (convert_id) {
        try {
            _ks_trace.push({event: 'form', convertId: convert_id, cb: function(){    console.log('Your callback function here!')}})
        } catch (e) {
            console.log(e)
        }
    },
};

export default _kuaishou
